const rtvPermission = 'user|rtv';
const chartsPermission = 'user|charts';
const adminPermission = 'user|administrator';
const searchPermission = 'user|search';

export {
  rtvPermission,
  chartsPermission,
  adminPermission,
  searchPermission,
};
